// extracted by mini-css-extract-plugin
module.exports = {"transfer-form":"transfer-form___1g8Zp","transfer-field":"transfer-field___12jMw"};